<template>
  <HealthFrame v-slot="{ error, forLabel }" v-bind="$attrs">
    <component :is="icon ? HealthIconField : 'div'" v-bind="icon ? { icon } : {}">
      <Password v-model="modelValue" :input-id="forLabel" :invalid="error" v-bind="props" />
    </component>
  </HealthFrame>
</template>

<script setup lang="ts">
  import Password from "primevue/password";
  import HealthFrame from "@/shared/components/form/HealthFrame.vue";
  import HealthIconField from "@/shared/components/form/HealthIconField.vue";
  import type { PasswordProps } from "./props.ts";

  const modelValue = defineModel();

  type Props = Omit<PasswordProps, "modelValue" | "error" | "forLabel">;

  const props = withDefaults(defineProps<Props>(), {
    toggleMask: true,
    fluid: true,
    feedback: false,
    size: "small",
  });
</script>
